import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Helmet } from 'react-helmet';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

const contentfulDocToHtmlStr = (document, replacementStr = '') => {
  if (!document) {
    return '';
  }
  return parse(documentToHtmlString(document).replace(/<p>/gi, replacementStr).replace(/<\/p>/gi, replacementStr));
};

const StaticBrandPage = ({ data }) => {
  const { html, css, javascript } = data;
  const htmlStr = contentfulDocToHtmlStr(html);
  const cssStr = contentfulDocToHtmlStr(css);
  const parsedJSStr = contentfulDocToHtmlStr(javascript, '\n\n');

  return (
    <>
      {(javascript || css) && (
        <Helmet>
          {javascript && <script type='text/javascript'>{parsedJSStr}</script>}
          {css && <style type='text/css'>{cssStr}</style>}
        </Helmet>
      )}
      {html && <div dangerouslySetInnerHTML={{ __html: htmlStr }} />}
    </>
  );
};

StaticBrandPage.propTypes = {
  data: PropTypes.object.isRequired,
};

StaticBrandPage.defaultProps = {};

export default StaticBrandPage;
